import * as yup from 'yup'

const schema = yup.object().shape({
  userName: yup.string().required('O username é obrigatório'),
  password: yup.string().required('A senha é obrigatória'),
  address: yup
    .string()
    .required('O endereço do servidor SMTP é obrigatório')
    .domain('O endereço do servidor SMTP deve ser válido'),
  port: yup
    .number()
    .required('A porta é obrigatória')
    .min(1, 'A porta deve ser maior que 0')
    .max(65535, 'A porta deve ser menor ou igual a 65535'),
  domain: yup.string().required('O domínio é obrigatório').domain(),
  authentication: yup
    .string()
    .oneOf(['login', 'plain', 'cram-md5'], 'Método de autenticação inválido')
    .required('O método de autenticação é obrigatório'),
  fromEmail: yup
    .string()
    .email('O e-mail de envio deve ser um e-mail válido')
    .required('O e-mail de envio é obrigatório'),
  active: yup.boolean().required('Obrigatório'),
  enableStarttlsAuto: yup.boolean().required('Obrigatório'),
})

export default schema
